// extracted by mini-css-extract-plugin
export default {"modifier":"Modifier_modifier__cT67U"};